import { FC } from 'react';
import { useSelector } from 'react-redux';
import { clientNameSelector } from '../../../../redux/auth/selectors';
import { raptorPlatformIdSelector } from '../../../../redux/raptorPlatform/selectors';
import { GeneralOverviewPageRenderedComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import LiquidityOverviewTable from './table';
import {
  activeSectionSelector,
  createSectionByIdSelector,
} from '../../../../redux/pages/selectors';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { RSOverviewPageModel } from '../../../../types/server-data/ClientConfig';
import {
  useLiquidityOverviewMonitorQuery,
  useLiquidityReportsListQuery,
} from '../../../../api/rs-hg/liquidity/hooks/queries';


const LiquidityOverview: FC<GeneralOverviewPageRenderedComponentProps
> = (
  props,
) => {
    const sectionDetails = useSelector(createSectionByIdSelector(props.section));
    const fundTypes = sectionDetails?.fundTypes;
    const clientName = useSelector(clientNameSelector);
    const currentSection = useSelector(activeSectionSelector);
    const selectedRaptorPlatformId = useSelector(raptorPlatformIdSelector);

    // only adepa have specific liquidity reports, for all other clients this should return empty array
    const liquidityReportsQuery = useLiquidityReportsListQuery({
      fundTypes,
      raptorPlatformId: selectedRaptorPlatformId,
    });

    const overviewQuery = useLiquidityOverviewMonitorQuery({
      positionDate: props.positionDate,
      fundTypes,
      raptorPlatformId: selectedRaptorPlatformId,
    });

    return (
      <QueryBoundary<{ overview: RSOverviewPageModel<any[]>; reports: any }>
        isLoading={liquidityReportsQuery.isLoading || overviewQuery.isLoading}
        isFetching={liquidityReportsQuery.isFetching || overviewQuery.isFetching}
        isError={!!liquidityReportsQuery.error || !!overviewQuery.error}
        error={liquidityReportsQuery.error || overviewQuery.error}
        data={
          overviewQuery.data && liquidityReportsQuery.data
            ? { overview: overviewQuery.data, reports: liquidityReportsQuery.data }
            : null
        }
        loadingMessages={['Loading Liquidity Overview Data...']}
        errorMessage="No Data Available."
        noDataMessage="No Data Available."
      >
        {({ overview, reports }) => (
          <LiquidityOverviewTable
            section={currentSection || 'liquidity'}
            overviewData={overview}
            reportsList={reports}
            clientName={clientName || 'mersenne'}
          />
        )}
      </QueryBoundary>
    );
  };

export default LiquidityOverview;
